/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box, Center, Group, Modal } from '@mantine/core';

// Components
import { Button, Text, Title } from '@components/v2/ui';

// Styles
import classes from './DefaultModal.module.css';

// I18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const DefaultModal = (props: {
	onConfirm: () => void;
	onClose: () => void;
	title: string;
	description?: string;
	opened: boolean;
	type?:
		| 'information'
		| 'OKOnly'
		| 'question'
		| 'warning';
}) => {
	/* ******************************** HOOKS *********************************** */
	const { t } = useTranslation();

	/* ******************************** RENDERING ******************************* */

	if (props.type == 'information') {
		return (
			<Modal
				opened={props.opened}
				onClose={props.onClose}
				classNames={classes}
				withCloseButton={false}
				size={500}
			>
				<Title ta="center" order={6} c={'#1D3965'}>
					{props.title}
				</Title>
				<Box className={classes.spacer} />
				<Text ta={'center'} variant="body1" c={'#1D3965'}>
					{props.description}
				</Text>
				<Group mt="xl" justify="center">
					<Button
						variant="primary"
						onClick={props.onClose}
					>
						{t('global.return')}
					</Button>
				</Group>
			</Modal>
		);
	}

	if (props.type == 'warning') {
		return (
			<Modal
				opened={props.opened}
				onClose={props.onClose}
				classNames={classes}
				withCloseButton={false}
				size={500}
			>
				<Center>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="82"
						height="82"
						viewBox="0 0 82 82"
						fill="none"
					>
						<path
							d="M41 29.8958V43.5624M35.1265 12.4406L9.55625 55.4451C6.84787 60.0001 10.1304 65.7708 15.4297 65.7708H66.5702C71.8696 65.7708 75.1521 60.0001 72.4437 55.4451L46.8735 12.4406C44.2248 7.98594 37.7752 7.98595 35.1265 12.4406Z"
							stroke="#FF381C"
							stroke-width="3"
							stroke-linecap="round"
						/>
						<circle
							cx="41"
							cy="52.9584"
							r="3.41667"
							fill="#FF381C"
						/>
					</svg>
				</Center>
				<Title ta="center" order={6} c={'#1D3965'}>
					{props.title}
				</Title>
				<Box className={classes.spacer} />
				<Text ta={'center'} variant="body1" c={'#1D3965'}>
					{props.description}
				</Text>
				<Group mt="xl" justify="center">
					<Button
						color="inputs-texts-icons"
						variant="transparent"
						onClick={props.onClose}
					>
						{t('global.cancel')}
					</Button>
					<Button
						variant="primary"
						onClick={props.onConfirm}
					>
						{t('global.iConfirm')}
					</Button>
				</Group>
			</Modal>
		);
	}

	return (
		<Modal
			opened={props.opened}
			onClose={props.onClose}
			classNames={classes}
			withCloseButton={false}
			size={500}
		>
			<Title ta="center" order={6} c={'#1D3965'}>
				{props.title}
			</Title>
			<Box className={classes.spacer} />

			<Text ta="center" variant="body1" c={'#1D3965'}>
				{props.description}
			</Text>

			<Group mt="xl" justify="center">
				<Button
					color="inputs-texts-icons"
					variant="transparent"
					onClick={props.onClose}
				>
					{t('global.cancel')}
				</Button>
				<Button
					variant="primary"
					onClick={props.onConfirm}
				>
					{t('global.iConfirm')}
				</Button>
			</Group>
		</Modal>
	);
};
